import { memo } from 'react';

import { cn } from '../../lib/styles';

type DividerProps = React.HTMLAttributes<HTMLDivElement>;

const DividerBase = ({ className, ...rest }: DividerProps) => {
  return <div className={cn('w-full border-t border-border-default', className)} data-slot="divider" {...rest} />;
};

export const Divider = memo(DividerBase);
